// BonBoZ: gom "khách đến từ quảng cáo nào" từ BA nguồn rời nhau.
//
// 1. `content_attributes.bonboz_ad` của ghi chú riêng — đường có cấu trúc,
//    giàu nhất. Store giữ snake_case; chỉ lúc render bubble mới camelCase.
// 2. Ghi chú markdown CŨ — tạo trước khi `AdsReferralService` gắn `bonboz_ad`.
//    Nội dung bài nằm trong chữ, ảnh nằm ở attachment của chính ghi chú. Toàn
//    bộ dữ liệu hiện có trong DB là loại này, nên bỏ qua nó là panel không bao
//    giờ có nội dung bài. Dùng lại đúng parser của thẻ trong khung chat.
// 3. `custom_attributes` — luôn có mã, nguồn, ref, kể cả khi ghi chú nằm ở đầu
//    một hội thoại dài và chưa được tải. Lớp này còn trả về `chi_o_contact` để
//    phân biệt "hội thoại này đến từ quảng cáo" với "khách này từng đến từ
//    quảng cáo" — hai câu rất khác nhau mà cùng một mã.
//
// Ghép từ nghèo tới giàu; khoá rỗng không được đè lên khoá đã có.
import { parseAdNote } from 'dashboard/components-next/message/bubbles/adNote';

const compact = obj =>
  Object.fromEntries(
    Object.entries(obj).filter(
      ([, v]) => v !== undefined && v !== null && v !== ''
    )
  );

/** Ảnh creative của ghi chú cũ nằm ở attachment. Store snake_case, bubble camel. */
const noteImage = message =>
  (message?.attachments || []).find(
    a => (a.file_type || a.fileType) === 'image'
  )?.data_url ??
  (message?.attachments || []).find(a => a.fileType === 'image')?.dataUrl;

const scan = (messages, pick) => {
  const list = messages || [];
  for (let i = list.length - 1; i >= 0; i -= 1) {
    const found = pick(list[i]);
    if (found) return found;
  }
  return null;
};

// Uu tien anh attachment cua chinh ghi chu: voi ad moi, backend da tai creative
// ve ActiveStorage nen `data_url` la URL local vinh vien, con `image_url` trong
// `bonboz_ad` luon la fbcdn ky + het han. Ghi chu cu attachment chi tru
// `external_url` (cung fbcdn) — khong te hon truoc.
const fromStructuredNote = messages =>
  scan(messages, m => {
    const ad = m?.content_attributes?.bonboz_ad;
    if (!ad?.ad_id) return null;
    return compact({ ...ad, image_url: noteImage(m) || ad.image_url });
  });

const fromLegacyNote = messages =>
  scan(messages, m => {
    if (!m?.private) return null;
    const { adId, body, permalinkUrl } = parseAdNote(m.content);
    if (!adId) return null;
    return compact({
      ad_id: adId,
      body,
      permalink_url: permalinkUrl,
      image_url: noteImage(m),
    });
  });

// Hội thoại trước contact: mỗi hội thoại mang nguồn riêng của nó, còn contact
// giữ mã ĐẦU TIÊN đưa khách tới (ads_referral_service.rb: stamp_contact).
const fromAttributes = (conversationAttrs, contactAttrs) => {
  const conv = conversationAttrs || {};
  const cont = contactAttrs || {};
  const laCuaHoiThoai = Boolean(conv.fb_ad_id);
  const src = laCuaHoiThoai ? conv : cont;
  const adId = String(src.fb_ad_id || '').trim();
  if (!adId) return null;
  return compact({
    ad_id: adId,
    title: src.ad_title,
    image_url: src.ad_photo_url || src.ad_video_url,
    source: src.ad_source,
    ref: src.ad_ref,
    // Dau con nay tra loi cau hoi "HOI THOAI NAY co tu quang cao khong", khac
    // han "khach nay tung tu quang cao khong". `stamp_contact` giu ma DAU TIEN
    // tren contact vinh vien (ads_referral_service.rb), nen mot khach tung bam
    // quang cao mot lan thi MOI hoi thoai ve sau cua ho deu doc ra co nguon —
    // ke ca hoi thoai ho tu nhan. Khong noi ro cho nay thi nguoi truc doc thanh
    // "hoi thoai nay den tu quang cao" va tu van sai huong.
    chi_o_contact: !laCuaHoiThoai,
  });
};

export const pickAdSource = (messages, conversationAttrs, contactAttrs) => {
  const tuGhiChu = [fromLegacyNote(messages), fromStructuredNote(messages)];
  const layers = [fromAttributes(conversationAttrs, contactAttrs), ...tuGhiChu];
  const coMat = layers.filter(Boolean);
  if (!coMat.length) return null;

  const gop = Object.assign({}, ...coMat);
  // Co ghi chu quang cao NGAY TRONG hoi thoai nay thi no la nguon cua chinh
  // hoi thoai, du `custom_attributes` cua hoi thoai chua kip duoc dong dau.
  if (tuGhiChu.some(Boolean)) gop.chi_o_contact = false;
  return gop;
};
